import { defineStore } from 'pinia';

interface AlertState {
  dismissSecs: number;
  dismissCountDown: number;
  alertType: string;
  alertMessage: Record<string, any>;
}

export const useAlertStore = defineStore('alert', {
  state: (): AlertState => ({
    dismissSecs: 0,
    dismissCountDown: 0,
    alertType: '',
    alertMessage: {},
  }),

  actions: {
    initAlert() {
      this.dismissSecs = 0;
      this.dismissCountDown = 0;
      this.alertType = '';
      this.alertMessage = {};
    },

    setAlertType(alertType: string) {
      this.alertType = alertType;
    },

    setAlertMessage(alertMessage: Record<string, any>) {
      this.dismissSecs = 5;
      this.dismissCountDown = 5;
      this.alertMessage = alertMessage;
    },

    countDownChanged(newCountDown: number) {
      this.dismissCountDown = newCountDown;
    },
  },
});
